module.exports = __webpack_public_path__ + "static/img/sign-orange.707e62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sign-orange.jpg
// module id = Gt56
// module chunks = 9